/**
 * Quick Add to Cart script
 *
 * Uses event delegation to listen for clicks on '.add-to-cart-button'.
 * This is performant and works with dynamically loaded content.
 * An IIFE and a window flag prevent the listener from being attached multiple times.
 */
(function () {
  // Check if this script has already run
  if (window.quickAddToCartBound) {
    return;
  }
  window.quickAddToCartBound = true;

  document.addEventListener('click', function (e) {
    // Find the button, even if the user clicked the SVG or span inside it
    const button = e.target.closest(
      '.add-to-cart-button:not(.product-card__button--out-of-stock)'
    );

    // If no matching button was clicked, do nothing
    if (!button) {
      return;
    }

    // We found an active add-to-cart button
    e.preventDefault();

    const productId = button.dataset.productId;
    const quantity = button.dataset.quantity;

    if (!productId) {
      console.error('Quick Add to Cart: Missing data-product-id attribute.');
      return;
    }

    // Find the cart notification or drawer component (standard in Dawn-based themes)
    const cartObject =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    // Prepare form data
    let formData = new FormData();
    formData.append('items[][id]', productId);
    formData.append('items[][quantity]', quantity || 1);

    if (cartObject && typeof cartObject.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartObject.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    // Add loading state to button (optional but good UX)
    button.classList.add('is-loading'); // You can style this class in your CSS
    button.disabled = true;

    // Use the global fetch API
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422) {
          // Handle errors, e.g., sold out
          console.error('Error:', data.description);
          // You could show an error message to the user here
        } else {
          // Success
          if (!cartObject) return;

          // These are standard methods on Shopify's cart components
          cartObject.classList.remove('is-empty');
          if (typeof cartObject.renderContents === 'function') {
            cartObject.renderContents(data);
          }
        }
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
      })
      .finally(() => {
        // Remove loading state
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  });
})();